import BaseService from "@client.services/baseService";

export default class SalaryRangeService extends BaseService {
  constructor() {
    super("salaryRange", true);
  }

  async getAll() {
    return super.api("");
  }
}
